import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
	palette: {
		primary: {
			main: '#2586bc',
			dark: '#3aa5d2',
			light: '#61afd2',
		},
		secondary: {
			main: '#af2c47',
		},
		error: {
			main: '#b91c1c',
			dark: '#991b1b',
			light: '#fee2e2',
		},
		warning: {
			main: '#b45309',
			dark: '#92400e',
			light: '#fef3c7',
		},
		grey: {
			main: '#544B50',
			dark: '#f6f5f9',
			hairline: '#949494',
		},
		green: {
			turquoise: '#00C3A5',
		},
		divider: '#2586bc',
		background: {
			default: '#ffffff',
			paper: '#f7f7f9',
		},
		text: {
			primary: '#1f2937',
			secondary: '#4b5563',
			disabled: '#6b7280',
			hint: '#374151',
			title: '#2586bc',
			highlight: '#357dac',
			section: '#085f91',
			placeholder: '#4a5568',
			contrast: '#0000008a',
		},
		surface: {
			page: '#f7fafc',
			panel: '#f4f9fc',
			soft: '#f9fcfe',
			alt: '#f9fafb',
			popover: '#fbfdff',
			selected: '#eff6ff',
			selectedChild: '#e0f2fe',
			neutral: '#edf2f7',
			stickyGradient: 'linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(255,255,255,0.94) 82%, rgba(255,255,255,0) 100%)',
			accentSoft: 'rgba(37, 134, 188, 0.10)',
			accentBorder: 'rgba(37, 134, 188, 0.25)',
			accentArea: 'rgba(37, 134, 188, 0.04)',
		},
		border: {
			main: '#d9e7f2',
			soft: '#dbe8f1',
			input: '#d5e4ef',
			muted: '#d1d5db',
			subtle: '#e5e7eb',
			button: '#c7d2da',
			dialog: '#cddbe7',
			overlay: 'rgba(213, 228, 239, 0.95)',
			section: 'rgba(219, 232, 241, 0.7)',
			inset: 'rgba(255, 255, 255, 0.85)',
			scrollbar: '#beb1b18f',
		},
		status: {
			success: '#047857',
			successSoft: '#dcfce7',
			successPanel: '#f0fdf4',
			online: '#66bb6a',
			offline: '#ef5350',
			inactive: '#9ca3af',
			scrollbarTrack: '#dfdfe957',
			scrollbarTrackLight: '#eff6fb',
			scrollbarThumb: '#b8d5e8',
		},
		shadow: {
			accent: '0 4px 10px rgba(37, 134, 188, 0.24)',
			card: '0 8px 24px rgba(15, 23, 42, 0.04)',
			sticky: '0 10px 24px rgba(15, 23, 42, 0.08)',
			search: '0 10px 26px rgba(15, 23, 42, 0.05)',
			dialog: '0 18px 44px rgba(15, 23, 42, 0.16)',
			dialogStrong: '0 18px 44px rgba(15, 23, 42, 0.18)',
			danger: '0 4px 10px rgba(185, 28, 28, 0.18)',
		},
	},
	typography: {
		fontFamily: `'Poppins', sans-serif`,

		subtitle1: { fontSize: 14, letterSpacing: 0.5, fontWeight: 700 },
		h6: { fontSize: 18, fontWeight: 700 },
	},
	borderRadiusBoxes: {
		borderRadius: 7,
	},
	scrollbars: {
		scrollsSettings: {
			overflow: 'scroll',
			marginBottom: '10px',
			overflowX: 'hidden',
		},
		webkitScrollbar: {
			background: 'white',
			borderStyle: 'solid',
			borderWidth: '1px',
			borderColor: '#beb1b18f',
			width: '9px',
		},
		webkitScrollbarTrack: {
			background: '#dfdfe957',
		},
	}
});

export default theme;
